import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { ProdutoDetail } from '../types'
import { produtosRepository } from './produtoRepository'

export const useProduto = makeUseFetchOne<ProdutoDetail, string>({
  fetch: produtosRepository.fetchOne
})
